<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="name"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
      v-bind="siteCFG.fields.general"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        default: null,
      },
      label: {
        type: String,
        default: "Assign Points Table",
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        data: "pointsTable/list",
        dataLoading: "pointsTable/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      pointsTable: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(JSON.stringify(this.data));
        this.model = this.id;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(JSON.stringify(this.data));
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.data.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
    },
  };
</script>
